export const siteStateStore = {
  dom: {
    headerEl: null as HTMLElement | null,
    footerEl: null as HTMLElement | null,
    splashEl: null as HTMLElement | null,
  },

  viewport: {
    winWidth: window.innerWidth,
    winHeight: window.innerHeight,
    docWidth: document.documentElement.clientWidth,
    docHeight: document.documentElement.clientHeight,
    scrollY: window.scrollY,
    scrollDir: null as 'up' | 'down' | null,

    // 比較用の前回値
    prev: {
      winWidth: window.innerWidth,
      winHeight: window.innerHeight,
      scrollY: window.scrollY,
    },
  },

  mouse: {
    x: 0,
    y: 0,

    // 比較用の前回値
    prev: {
      x: 0,
      y: 0,
    },

    // -1〜1 に正規化
    normalized: {
      x: 0,
      y: 0,
    },
  },

  rafId: null as number | null,
};
